/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessType,
  AnchorType,
  AttachProjectSceneRequestDto,
  CreateProjectFolderRequestDto,
  ProblemDetails,
  ProjectAccessorRequestDto,
  ProjectAccessorResponseDto,
  ProjectActionRequestDto,
  ProjectAndScenePermissionsResponseDto,
  ProjectFolderResponseDto,
  ProjectResponseDto,
  QueryFlagType,
  SceneResponseDto,
  TeamProjectShareRequestDto,
  TransferRequestDto,
  UpdateProjectFolderRequestDto,
  UserProjectShareRequestDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Projects<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description If latitude and longitude are provided, it returns only projects within the given distance (meters). Default 2000m, min 500m, max 5000m. - SuperAdmins: See all active or public projects. - Regular users: Only see projects linked to their teams (TeamProjects) that are active or public.
   *
   * @tags Projects
   * @name ProjectsList
   * @summary Retrieves all accessible projects for the current user.
   * @request GET:/projects
   * @secure
   */
  projectsList = (
    query?: {
      /** @format double */
      latitude?: number;
      /** @format double */
      longitude?: number;
      /** @format int32 */
      distance?: number;
      queryFlag?: QueryFlagType;
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectResponseDto[], ProblemDetails | void>({
      path: `/projects`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Allows a team member with appropriate permissions to create a new project. - Requires team membership with permission higher than Viewer. - Uploads logo and graphic images to Azure Blob Storage. - Links scenes and sets access metadata (e.g., location). - The created project is linked to the specified team with 'Owner' permissions.
   *
   * @tags Projects
   * @name ProjectsCreate
   * @summary Creates a new project.
   * @request POST:/projects
   * @secure
   */
  projectsCreate = (
    data: {
      Name: string;
      Description?: string;
      ActivationStatus?: string;
      Color?: string;
      AllowFolder?: boolean;
      SkipWelcomeScreen?: boolean;
      /** @format uuid */
      TeamId: string;
      /** @format binary */
      LogoImage: File;
      /** @format binary */
      GraphicImage?: File;
      SceneIds?: string[];
      Tags?: string[];
      AccessType: AccessType;
      Address?: string;
      /** @format double */
      Latitude?: number;
      /** @format double */
      Longitude?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectResponseDto, ProblemDetails | void>({
      path: `/projects`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Allows a user with edit-level permissions to update an existing project. **Access Control:** - The user must belong to the team linked to the project. - The user's permission level must be higher than 'Viewer'. **Functionality:** - Updates core project fields. - Handles optional logo and graphic image uploads to Azure Blob Storage. - Updates project scenes (clears and re-adds). - If `IsAnnouncement` is set, clears that flag from other projects.
   *
   * @tags Projects
   * @name ProjectsPartialUpdate
   * @summary Updates an existing project.
   * @request PATCH:/projects/{projectId}
   * @secure
   */
  projectsPartialUpdate = (
    projectId: string,
    data: {
      /** @format uuid */
      TeamId: string;
      Name: string;
      Description?: string;
      ActivationStatus?: string;
      AllowFolder?: boolean;
      Color?: string;
      SkipWelcomeScreen?: boolean;
      IsAnnouncement?: boolean;
      /** @format binary */
      LogoImage?: File;
      /** @format binary */
      GraphicImage?: File;
      SceneIds?: string[];
      Tags?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ProjectResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Marks the specified project as deleted and deactivates it. **Access Control:** - The user must belong to the team associated with the project. - The user's permission level must be higher than 'Viewer'. **Functionality:** - Soft-deletes the project by marking `IsDeleted`, `IsActive`, and `IsDeletedPermanent`. - Records the deletion timestamp. - Deletes related project scenes and accessors.
   *
   * @tags Projects
   * @name ProjectsDelete
   * @summary Deletes a project (soft delete).
   * @request DELETE:/projects/{projectId}
   * @secure
   */
  projectsDelete = (
    projectId: string,
    data: ProjectActionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Retrieves a project's details using either its unique `Guid` or `ShortCode`. **Functionality:** - If `projectId` is a valid GUID, it fetches by `Id`. - Otherwise, it tries to fetch by `ShortCode`. - Includes related `ProjectScenes` and `ProjectAccessors`, with nested `Scene` data. **Returns:** - Project data if found and not deleted. **Throws:** - `400 Bad Request` if the project is not found.
   *
   * @tags Projects
   * @name ProjectsDetail
   * @summary Gets a project by ID or shortcode.
   * @request GET:/projects/{projectId}
   * @secure
   */
  projectsDetail = (projectId: string, params: RequestParams = {}) =>
    this.request<ProjectResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reassigns ownership of the project (and all of its scenes) to the target team. Pending invitations on the project and its scenes are cleared. Published projects are temporarily unpublished and re-published only if the destination team's activation quota allows. **Permissions:** SuperAdmin can transfer any project. Regular users must be the creator owner (IsCreator) of both the source project's team and the destination team. **Returns:** `204 No Content` on success. **Error Codes:** `400 BadRequest` - Project or destination team not found. `403 Forbidden` - Caller is not authorized to transfer between these teams. `500 InternalServerError` - Unexpected server-side error.
   *
   * @tags Projects
   * @name TransferCreate
   * @summary Transfer a project to another team
   * @request POST:/projects/{projectId}/transfer
   * @secure
   */
  transferCreate = (
    projectId: string,
    data: TransferRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}/transfer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Fetches all scenes associated with a given project. **Behavior:** - Validates if the project exists using the provided `projectId`. - Retrieves related `ProjectScenes` and includes their nested `Scene` and `SceneAccessors`. - Skips any `ProjectScene` entries that have null `Scene` references. **Returns:** - A list of scenes linked to the project as `SceneResponseDto`.
   *
   * @tags Projects
   * @name ScenesList
   * @summary Get scenes for a specific project
   * @request GET:/projects/{projectId}/scenes
   * @secure
   */
  scenesList = (projectId: string, params: RequestParams = {}) =>
    this.request<SceneResponseDto[], ProblemDetails | void>({
      path: `/projects/${projectId}/scenes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description **DEPRECATED** — Use POST {projectId}/scenes/upload instead. Creates a new scene by uploading content and attaches it to the specified project.
   *
   * @tags Projects
   * @name ScenesPartialUpdate
   * @summary Upload and attach a scene to a project (Deprecated)
   * @request PATCH:/projects/{projectId}/scenes
   * @deprecated
   * @secure
   */
  scenesPartialUpdate = (
    projectId: string,
    data: {
      /** @format uuid */
      TeamId: string;
      "Scene.Name": string;
      "Scene.Description"?: string;
      "Scene.ActivationStatus"?: string;
      /** @format uuid */
      "Scene.TeamId": string;
      /** @format double */
      "Scene.ImageWidth"?: number;
      /** @format binary */
      "Scene.Image"?: File;
      "Scene.Tags"?: string[];
      "Scene.AccessType": AccessType;
      "Scene.AnchorType": AnchorType;
      "Scene.Address"?: string;
      /** @format double */
      "Scene.Latitude"?: number;
      /** @format double */
      "Scene.Longitude"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/scenes`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Associates a scene with a project, ensuring both the project and scene exist and the team has sufficient permissions. **Validations:** - Checks if the scene and project exist. - Ensures the team associated with the request has permissions on both the scene and the project. - Prevents duplicate associations by checking if the scene is already linked to any project. **Outcome:** - On success, attaches the scene to the project. - Returns `204 No Content`.
   *
   * @tags Projects
   * @name ScenesPartialUpdate2
   * @summary Attach a scene to a project
   * @request PATCH:/projects/{projectId}/scenes/{sceneId}
   * @originalName scenesPartialUpdate
   * @duplicate
   * @secure
   */
  scenesPartialUpdate2 = (
    projectId: string,
    sceneId: string,
    data: AttachProjectSceneRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}/scenes/${sceneId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Removes the association between a scene and a project if it exists. **Validations include:** - Checks if the project, scene, and team exist. - Ensures the requesting team has at least edit-level permission on the project. - Only executes deletion if the relationship is found. **Outcome:** - On success, the scene is detached from the project. - Returns `204 No Content`.
   *
   * @tags Projects
   * @name ScenesDelete
   * @summary Detach a scene from a project
   * @request DELETE:/projects/{projectId}/scenes/{sceneId}
   * @secure
   */
  scenesDelete = (
    sceneId: string,
    projectId: string,
    data: {
      /** @format uuid */
      TeamId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}/scenes/${sceneId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * @description Creates a new scene by uploading content and attaches it to the specified project. - Requires a valid `projectId` in the route and a multipart/form-data request body containing scene data. - The project must exist and allow new scenes based on quota. - The team must have permission higher than Viewer on both the scene and the project. - The uploaded scene is inserted into the database, then linked to the project. - If the project supports folders and has a default folder, the scene is assigned to it automatically. - Updates the scene's activation status to match the project. - Returns 400 for validation errors, quota issues, duplicate attachments, or permission violations. - On success, returns the full `SceneResponseDto` containing the new scene's details.
   *
   * @tags Projects
   * @name ScenesUploadCreate
   * @summary Uploads and attaches a new scene to a project.
   * @request POST:/projects/{projectId}/scenes/upload
   * @secure
   */
  scenesUploadCreate = (
    projectId: string,
    data: {
      /** @format uuid */
      TeamId: string;
      "Scene.Name": string;
      "Scene.Description"?: string;
      "Scene.ActivationStatus"?: string;
      /** @format uuid */
      "Scene.TeamId": string;
      /** @format double */
      "Scene.ImageWidth"?: number;
      /** @format binary */
      "Scene.Image"?: File;
      "Scene.Tags"?: string[];
      "Scene.AccessType": AccessType;
      "Scene.AnchorType": AnchorType;
      "Scene.Address"?: string;
      /** @format double */
      "Scene.Latitude"?: number;
      /** @format double */
      "Scene.Longitude"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/scenes/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches the project that is marked as an announcement, ensuring it is not deleted. **Guest Users can Access this endpoint.** **Validations include:** - Ensures the project exists and is marked as an announcement. - Returns the project details including related scenes and accessors. **Outcome:** - On success, the details of the announcement project are returned.
   *
   * @tags Projects
   * @name AnnouncementsList
   * @summary Get the announcement project
   * @request GET:/projects/announcements
   * @secure
   */
  announcementsList = (params: RequestParams = {}) =>
    this.request<ProjectResponseDto, ProblemDetails | void>({
      path: `/projects/announcements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches the list of accessors for a specific project identified by its project ID. **Validations include:** - Ensures the project exists. - Retrieves a list of accessors related to the project. **Outcome:** - Returns a list of project accessors in the response.
   *
   * @tags Projects
   * @name AccessorsList
   * @summary Get project accessors by project ID
   * @request GET:/projects/{projectId}/accessors
   * @secure
   */
  accessorsList = (projectId: string, params: RequestParams = {}) =>
    this.request<ProjectAccessorResponseDto[], ProblemDetails | void>({
      path: `/projects/${projectId}/accessors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Creates one accessor on the project. Idempotent: if an Anywhere accessor already exists (or a Location accessor with the same precision-6 geohash, ~1km cell), the existing accessor is returned with HTTP 200 and no row is inserted. For batched edits where the client owns the desired list, use `PUT /accessors` instead — that endpoint diffs the list against the project's current state. **Validations:** - Project must exist and not be deleted. - `Location` requires both `latitude` and `longitude`. - Caller must be SuperAdmin or have Editor/Owner permission on the project via team membership.
   *
   * @tags Projects
   * @name AccessorsCreate
   * @summary Create a single accessor on a project
   * @request POST:/projects/{projectId}/accessors
   * @secure
   */
  accessorsCreate = (
    projectId: string,
    data: ProjectAccessorRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ProjectAccessorResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/accessors`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Sets the project's accessors to the supplied list. The server diffs against the current state: - Items in the request that match an existing accessor (Anywhere↔Anywhere, or Location with the same precision-6 geohash, ~1km cell) are reported `Kept` — existing rows are left alone. - Items in the request that don't match an existing accessor are inserted and reported `Created`. - Existing accessors not matched by any request item are deleted and reported `Removed`. - Within-batch duplicates (e.g. two identical Locations in the same payload) are reported `Skipped` with a `reason`. If the diff would leave the project with zero accessors, an `Anywhere` accessor is auto-added so the invariant holds. **Validations:** - Project must exist and not be deleted. - `Location` items missing `latitude`/`longitude` are silently dropped. - Caller must be SuperAdmin or have Editor/Owner permission on the project via team membership.
   *
   * @tags Projects
   * @name AccessorsUpdate
   * @summary Replace the project's accessor list (with diff)
   * @request PUT:/projects/{projectId}/accessors
   * @secure
   */
  accessorsUpdate = (
    projectId: string,
    data: ProjectAccessorRequestDto[],
    params: RequestParams = {},
  ) =>
    this.request<ProjectAccessorResponseDto[], ProblemDetails | void>({
      path: `/projects/${projectId}/accessors`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows you to update an existing accessor for a specific project. The update can include location-based data (latitude and longitude), and other fields like the access type. The accessor's information is modified in the database based on the provided request data. **Validations include:** - Ensures that the project accessor exists and belongs to the given project. - Ensures that location data is provided for `Location` access type. - Updates the accessor fields in the database. **Outcome:** - Returns the updated accessor information as a response.
   *
   * @tags Projects
   * @name AccessorsPartialUpdate
   * @summary Update an accessor for a project
   * @request PATCH:/projects/{projectId}/accessors/{accessorsId}
   * @secure
   */
  accessorsPartialUpdate = (
    projectId: string,
    accessorsId: string,
    data: ProjectAccessorRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ProjectAccessorResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/accessors/${accessorsId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows you to delete an existing accessor for a specific project. Once deleted, the accessor will no longer have access to the project and any related data will be removed from the system. The deletion is permanent and cannot be undone. **Validations include:** - Ensures that the accessor exists and belongs to the given project. **Outcome:** - If successful, returns HTTP 204 No Content, indicating the accessor was successfully deleted. - If the accessor is not found, an error message is returned.
   *
   * @tags Projects
   * @name AccessorsDelete
   * @summary Delete an accessor from a project
   * @request DELETE:/projects/{projectId}/accessors/{accessorsId}
   * @secure
   */
  accessorsDelete = (
    projectId: string,
    accessorsId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}/accessors/${accessorsId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description This endpoint allows you to retrieve details about a specific accessor associated with a project. You must provide the project ID and accessor ID to fetch the accessor's data. **Validations include:** - Ensures that the accessor exists and belongs to the given project. **Outcome:** - If successful, returns the accessor details with HTTP 200 OK. - If the accessor is not found, an error message is returned with HTTP 400 Bad Request.
   *
   * @tags Projects
   * @name AccessorsDetail
   * @summary Get a specific accessor by project and accessor ID
   * @request GET:/projects/{projectId}/accessors/{accessorsId}
   * @secure
   */
  accessorsDetail = (
    projectId: string,
    accessorsId: string,
    params: RequestParams = {},
  ) =>
    this.request<ProjectAccessorResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/accessors/${accessorsId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint retrieves the permissions associated with members of a specific project. The result includes user permissions, team permissions, and user invitations for the given project ID. **Validations include:** - Ensures that the project exists for the provided project ID. **Outcome:** - If successful, returns the project details along with associated permissions and users in HTTP 200 OK. - If the project is not found, returns a HTTP 400 Bad Request response.
   *
   * @tags Projects
   * @name MembersList
   * @summary Get project permissions for members
   * @request GET:/projects/{projectId}/members
   * @secure
   */
  membersList = (projectId: string, params: RequestParams = {}) =>
    this.request<ProjectAndScenePermissionsResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/members`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows you to share a project with specified teams. You can manage the teams, revoke access, and update permissions based on the provided request. The process involves verifying the project and permissions before making any changes. **Validations include:** - Ensures that the project exists for the provided project ID. - Verifies the permissions of the team to ensure they have the appropriate access level. **Outcome:** - If successful, returns HTTP 204 No Content indicating the project was successfully shared. - If the project is not found, returns HTTP 400 Bad Request response. - If there are permission issues, returns HTTP 400 Bad Request response.
   *
   * @tags Projects
   * @name MembersTeamsCreate
   * @summary Share project with teams
   * @request POST:/projects/{projectId}/members/teams
   * @secure
   */
  membersTeamsCreate = (
    projectId: string,
    data: TeamProjectShareRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}/members/teams`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This endpoint allows you to share a project with specific users, manage user memberships, and update their permissions. You can also revoke access for users, including unregistered users, based on the provided request. The operation ensures that the project and permissions are validated before proceeding. **Validations include:** - Ensures the project exists for the given project ID. - Verifies the team has sufficient permissions to modify project access and permissions. **Outcome:** - On success, returns HTTP 204 No Content, indicating that the project has been successfully shared. - If the project is not found, it will return HTTP 400 Bad Request. - If the permissions are insufficient, it will return HTTP 400 Bad Request.
   *
   * @tags Projects
   * @name MembersUsersCreate
   * @summary Share project with users
   * @request POST:/projects/{projectId}/members/users
   * @secure
   */
  membersUsersCreate = (
    projectId: string,
    data: UserProjectShareRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/projects/${projectId}/members/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Allows a project member to create a new folder within an existing project. - Requires a valid `projectId` and a `Title` for the folder in the request body. - The project must exist and not be marked as deleted. - Duplicate folder titles within the same project are not allowed. - Returns 400 if the request is invalid, the project is not found, or the folder title already exists. - On success, returns the created folder details.
   *
   * @tags Projects
   * @name FoldersCreate
   * @summary Creates a new folder within a specified project.
   * @request POST:/projects/{projectId}/folders
   * @secure
   */
  foldersCreate = (
    projectId: string,
    data: CreateProjectFolderRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ProjectFolderResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/folders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Allows a project member to update the details of an existing folder. - Requires valid `projectId` and `folderId` in the route. - Folder must exist and belong to the specified project. - The `Title` field in the request body must not be empty. - Duplicate folder titles within the same project (excluding the current folder) are not allowed. - Returns 400 if the folder is not found, the title is invalid, or the new title conflicts with another folder. - On success, returns the updated folder details.
   *
   * @tags Projects
   * @name FoldersPartialUpdate
   * @summary Updates an existing folder within a project.
   * @request PATCH:/projects/{projectId}/folders/{folderId}
   * @secure
   */
  foldersPartialUpdate = (
    projectId: string,
    folderId: string,
    data: UpdateProjectFolderRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ProjectFolderResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/folders/${folderId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches detailed information about a folder belonging to a specific project. - Requires valid `projectId` and `folderId` in the route. - The folder must exist and be linked to the given project. - Includes related scenes and their access information in the response. - Returns 400 if the folder is not found. - On success, returns the full folder details including nested scene access data.
   *
   * @tags Projects
   * @name FoldersDetail
   * @summary Retrieves a specific folder within a project.
   * @request GET:/projects/{projectId}/folders/{folderId}
   * @secure
   */
  foldersDetail = (
    projectId: string,
    folderId: string,
    params: RequestParams = {},
  ) =>
    this.request<ProjectFolderResponseDto, ProblemDetails | void>({
      path: `/projects/${projectId}/folders/${folderId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Removes a specific folder from a given project along with its associations. - Requires valid `projectId` and `folderId` in the route. - The specified project must exist and must allow folders (`AllowFolder == true`). - The folder must exist and belong to the specified project. - Associated scenes are soft-deleted and their `ProjectFolderId` references are cleared. - Returns 400 if the project or folder is not found. - Returns `false` if the project does not allow folders. - On success, returns `true` after deletion is completed.
   *
   * @tags Projects
   * @name FoldersDelete
   * @summary Deletes a folder within a project.
   * @request DELETE:/projects/{projectId}/folders/{folderId}
   * @secure
   */
  foldersDelete = (
    projectId: string,
    folderId: string,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ProblemDetails | void>({
      path: `/projects/${projectId}/folders/${folderId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reassigns a scene to a different folder within the same project. - Requires valid `projectId`, `folderId`, and `sceneId` in the route. - The project must exist and support folders. - The target folder must belong to the specified project. - The scene must exist and be associated with the given project. - Returns 400 if the project, folder, or scene is not found or invalid. - On success, moves the scene under the specified folder and returns `true`.
   *
   * @tags Projects
   * @name FoldersScenesPartialUpdate
   * @summary Moves a scene into a specific project folder.
   * @request PATCH:/projects/{projectId}/folders/{folderId}/scenes/{sceneId}
   * @secure
   */
  foldersScenesPartialUpdate = (
    projectId: string,
    folderId: string,
    sceneId: string,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ProblemDetails | void>({
      path: `/projects/${projectId}/folders/${folderId}/scenes/${sceneId}`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
}
